import React from 'react';
import {Table} from 'antd';
import { useHistory } from 'react-router-dom';

const columns = [
    {
        title: "AGENT CODE",
        dataIndex: "agent_code",
        sorter: (a, b) => a.agent_code.localeCompare(b.agent_code),
        sortDirections: ['ascend', 'descend', 'ascend'],
        key: "agent_code",
        width: "15%"
    },
    {
        title: "LAST NAME",
        dataIndex: "last_name",
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.last_name.localeCompare(b.last_name),
        sortDirections: ['ascend', 'descend', 'ascend'],
        key: "last_name",
        width: "25%"
    },
    {
        title: "FIRST NAME",
        dataIndex: "first_name",
        key: "first_name",
        width: "25%"
    },
    {
        title: "MIDDLE NAME",
        dataIndex: "middle_name",
        key: "middle_name",
        width: "25%"
    },
    {
        title: "STATUS",
        dataIndex: "status",
        key: "status",
        width: "10%"
    },
];

function SearchAgentTable(props) {

    const history = useHistory();
    const { data, pageSize } = props;
    return(
        <div>
            <Table
                // style={ {textTransform: "uppercase"} }
                dataSource = {data}
                // @ts-ignore
                columns={columns}
                showSorterTooltip={false}
                bordered
                pagination={{ pageSize }}
                onRow={(record) => {
                    return {
                        onDoubleClick: (e) => history.push('/agent/update_agent', record)
                    };
                }}
            />
        </div>
    )
}

export default SearchAgentTable;